import { onlyNumbersRule } from '@scripts/rules/baseRules'

export const datepickerInputRule = (value: string) => {
  let preparedValue = value
    .replace(/[^0-9/]/g, '')
    .replace(/[/]{2,}/g, '/')
    .substring(0, 10)

  if (/^[0-9]{2}[/]{1}$/.test(preparedValue) || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}$/.test(preparedValue) || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}$/.test(preparedValue)) {
    return preparedValue
  }

  preparedValue = onlyNumbersRule(value).substring(0, 8)

  if (preparedValue.length > 4) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2, 4)}/${preparedValue.slice(4)}`
  }

  if (preparedValue.length > 2) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2)}`
  }

  return preparedValue
}

export const datepickerInputRangeRule = (value: string) => {
  let preparedValue = value
    .replace(/[^0-9/\-\s]/g, '')
    .replace(/[/]{2,}/g, '/')
    .replace(/[\s]{2,}/g, ' ')
    .replace(/[\-]{2,}/g, '-')
    .substring(0, 23)

  if (
    /^[0-9]{2}[/]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}[\-]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}[\-]{1}[\s]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}[\-]{1}[\s]{1}[0-9]{2}[/]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}[\-]{1}[\s]{1}[0-9]{2}[/]{1}[0-9]{2}[/]{1}$/.test(preparedValue)
      || /^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}[\s]{1}[\-]{1}[\s]{1}[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{1,4}$/.test(preparedValue)
  ) {
    return preparedValue
  }

  preparedValue = onlyNumbersRule(value).substring(0, 16)

  if (preparedValue.length > 12) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2, 4)}/${preparedValue.slice(4, 8)} - ${preparedValue.slice(8, 10)}/${preparedValue.slice(10, 12)}/${preparedValue.slice(12)}`
  }

  if (preparedValue.length > 10) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2, 4)}/${preparedValue.slice(4, 8)} - ${preparedValue.slice(8, 10)}/${preparedValue.slice(10)}`
  }

  if (preparedValue.length > 8) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2, 4)}/${preparedValue.slice(4, 8)} - ${preparedValue.slice(8)}`
  }

  if (preparedValue.length > 4) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2, 4)}/${preparedValue.slice(4)}`
  }

  if (preparedValue.length > 2) {
    return `${preparedValue.slice(0, 2)}/${preparedValue.slice(2)}`
  }

  return preparedValue
}
